import React from "react";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const ActionIconsTableItem = ({ props }) => {
  return (
    <div
      className="d-flex"
      style={{ marginLeft: props.notes ? "-20px" : "" }}
    >
      <div className="dropdown my-auto">
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip className="tooltip-small">More actions</Tooltip>}
        >
          <a
            className="rounded-circle text-secondary mx-2 pointer"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa-regular p-2 fa-chevron-right"></i>
          </a>
        </OverlayTrigger>
        <ul
          className="dropdown-menu dropdown-menu-end"
          aria-labelledby="dropdownMenuButton"
        >
          <li>
            <a
              className="dropdown-item pointer"
              href={props.immunization_url}
            >
              View immunization details
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ActionIconsTableItem;